module.exports = __webpack_public_path__ + "static/musee_olympique_livre3D4-28534854baf8e057949bb31d112377a9.png";